import Storage from '../services/Storage'
import Api from "../services/Api";
import Jwt from "../services/Jwt";
import Constants from "../services/Constants";

const initialState = {
  userState: undefined
};

export function login(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN.SUCCESS': {
      const {headers, body: {dealerName}} = action.user;
      const token = headers.get('Authorization');
      const user = Jwt.decode(token);
      Storage.setItem('token', token);
      Storage.setItem('user', user);
      Storage.setItem('dn', dealerName);

      Storage.removeSessionItem('token');
      Storage.removeSessionItem('user');

      Api.setHeader('Authorization', token);
      return {
        ...state,
        userState: 'signed-in',
      }
    }
    case 'LOGOUT.SUCCESS': {
      Storage.removeItem('token');
      Storage.removeItem('user');
      Storage.setItem('dn');
      Api.removeHeader('Authorization');
      return {
        ...state,
        userState: 'auth-failure',
      }
    }
    case 'FETCH.CUSTOMER_EXCHANGE_TOKEN.SUCCESS':
    case 'FETCH.CUSTOMER_LOGIN.SUCCESS': {
      const {headers} = action.response;
      const token = headers.get('Authorization');

      const connectedToken = headers.get(Constants.AUTH_CONSTANTS.ACCESS_TOKEN_HEADER);
      const connectedRefreshToken = headers.get(Constants.AUTH_CONSTANTS.REFRESH_TOKEN_HEADER);
      const connectedTokenExpiration = headers.get(Constants.AUTH_CONSTANTS.REFRESH_TOKEN_EXPIRATION);
      const user = Jwt.decode(token);
      Storage.setSessionItem('token', token);
      Storage.setSessionItem('user', user);
      Storage.setSessionItem('connected-token', connectedToken);
      Storage.setSessionItem('connected-refresh-token', connectedRefreshToken);
      Storage.setSessionItem('connected-token-expiration', connectedTokenExpiration);


      Storage.removeItem('token');
      Storage.removeItem('user');

      Api.setHeader('Authorization', token);
      Api.setHeader('x-connected-token', connectedToken);

      return {
        ...state,
        userState:  'signed-in',
      }
    }
    case 'FETCH.CUSTOMER_REFRESH_TOKEN.SUCCESS': {
      const {headers} = action.response;
      const connectedToken = headers.get(Constants.AUTH_CONSTANTS.ACCESS_TOKEN_HEADER);
      const connectedRefreshToken = headers.get(Constants.AUTH_CONSTANTS.REFRESH_TOKEN_HEADER);
      const connectedTokenExpiration = headers.get(Constants.AUTH_CONSTANTS.REFRESH_TOKEN_EXPIRATION);

      Storage.setSessionItem('connected-token', connectedToken);
      Storage.setSessionItem('connected-refresh-token', connectedRefreshToken);
      Storage.setSessionItem('connected-token-expiration', connectedTokenExpiration);

      Api.setHeader('x-connected-token', connectedToken);

      return {...state}
    }
    case 'CUSTOMER_LOGOUT.SUCCESS': {
      Storage.customerLogout();
      Api.removeHeader('Authorization');
      Api.removeHeader('x-connected-token');
      return {
        ...state,
        userState: 'logout',
      }
    }
    default:
      return state
  }
}
